import React from "react";

export default props =>
  <>
    <div className="post__comments" data-slug={props.slug}></div>
  </>